import { z } from "zod";

/**
 * Tuning every E2B agent sandbox reads, shared by yeet and social analyse so
 * the two cannot drift. `agent-runtime`'s runner takes this type directly.
 *
 * `sandboxTemplate` names a provisioned E2B template; its build marker is baked
 * into the image, so changing the name means provisioning a new template first.
 */
export const SandboxTuningConfigSchema = z.object({
  nodeHeapMb: z.number().int().positive().default(300),
  sandboxTemplate: z.string().default("yeet-browserless-512mb"),
  expectedSandboxMemoryMb: z.number().int().positive().default(512),
  sandboxMemoryDriftToleranceMb: z.number().int().min(0).default(64),
  // Cadence at which the dispatcher heartbeats the attempt-extend endpoint
  // while the agent runs (sliding sandbox deadline).
  extendHeartbeatMs: z.number().int().positive().default(60_000),
  // Time reserved at the end of the budget for the dispatcher to report.
  reportMarginMs: z.number().int().positive().default(30_000),
  // Slack between the attempt deadline and the sandbox's own timeout.
  sandboxGraceMs: z.number().int().positive().default(60_000),
  outputTailChars: z.number().int().positive().default(4_000),
});
export type SandboxTuningConfig = z.infer<typeof SandboxTuningConfigSchema>;
